export default __webpack_public_path__ + "static/media/PridedickWoman.3cfdd37b.png";